export const resetGiftCardState = (state, dispatch) => {
  const { postData } = state
  if (postData) {
    dispatch({
      type: 'RESET_STATE',
      state: {
        giftOption: state.giftOption,
        deliverAfter: state.deliveryDate,
        deliveryDateUpdated: true,
        deliveryMethod: postData.notifyRecipient ? 'Email' : 'Print',
        giftCardPrice: state.giftCardPrice ? state.giftCardPrice : null,
        occasion: state.occasion,
        personalMessage: postData.messageBody,
        recipientEmail: postData.recipientEmail,
        recipientFirst: state.recipientFirst,
        recipientLast: state.recipientLast
      }
    })
  }
}
